<template>
  <ion-page>
    <PageHeaderWithMenu title="Пользователи" :scrolled="headerScrolled" />
    <ion-content :class="[isMobile ? 'main-background users-page-mobile' : 'liga-web-background']" :fullscreen="true" slot="fixed"
      :scroll-y="false">
      <div class="users-top-section">
      <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
        @ionInput="onSearchChange($event)" :debounce="500"></ion-searchbar>
      <ion-item class="filter-field-clear-button" lines="none">
        <ion-item class="filter-field" lines="none">
          <ion-select label="Группы прав" v-model="authoritiesFilter" :multiple="true" placeholder="Не выбрано" cancel-text="Отмена"
            mode="ios" :interface-options="customSelectOptions">
            <ion-select-option v-for="authority in allAuthorities" :key="authority.name" :value="authority.name">{{
              authority.description }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-icon slot="end" :icon="closeOutline" @click="clearFilter('authorities')"></ion-icon>
      </ion-item>
      <ion-item class="filter-field-clear-button" lines="none">
        <ion-item class="filter-field" lines="none">
          <ion-select label="Допуск к отдельным релизам" :value="releasesFilter" :multiple="true" placeholder="Не выбрано" cancel-text="Отмена"
            mode="ios" :interface-options="customSelectOptions" @ionChange="onReleasesFilterChange">
            <ion-select-option v-for="r in allReleases" :key="r.id" :value="r.id">{{
              r.program ? r.program.programName : '' }} {{ r.releaseName }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-icon slot="end" :icon="closeOutline" @click="clearFilter('releases')"></ion-icon>
      </ion-item>
      </div>
      <div class="users-total-above-list">
        <span class="users-total-label">Всего: {{ totalItems }}</span>
        <div class="users-total-actions">
          <ion-button fill="clear" size="small" class="users-refresh-btn" @click="requestUsers()" title="Обновить список">
            <ion-icon :icon="refreshOutline"></ion-icon>
          </ion-button>
          <ion-button size="small" fill="solid" shape="round" class="users-panel-btn users-panel-btn-cache" @click="refreshRolesCache()" title="Обновить кеш ролей у всех пользователей">
            <ion-icon slot="start" :icon="refreshOutline"></ion-icon>
            Кеш ролей
          </ion-button>
          <ion-button size="small" fill="solid" shape="round" class="users-panel-btn users-panel-btn-create" @click="openCreateUserModal()" title="Создать учетную запись">
            <ion-icon slot="start" :icon="personAddOutline"></ion-icon>
            Создать
          </ion-button>
          <ion-button size="small" fill="outline" shape="round" class="users-panel-btn users-panel-btn-activity" @click="openActivityModal()" title="Просмотр активности">
            <ion-icon slot="start" :icon="statsChartOutline"></ion-icon>
            Активность
          </ion-button>
          <ion-button size="small" fill="outline" shape="round" class="users-panel-btn users-panel-btn-groups" @click="openUserGroupsSelector()" title="Группы прав">
            <ion-icon slot="start" :icon="keyOutline"></ion-icon>
            Группы
          </ion-button>
        </div>
      </div>
      <ion-content class="bg-transparent users-list-scroll" @ionScroll="onContentScroll">
        <div v-if="usersLoading" class="users-loading">Загрузка...</div>
        <ion-list v-show="!usersLoading && totalItems > 0" class="bg-transparent" lines="none">
          <ion-item v-for="user in users" :key="user.id" lines="none" class="user-item"
            @click="openUserSettings(user)">
            <ion-label class="ion-margin-start">
              <p class="user-name">{{ user.lastName }} {{ user.firstName }}</p>
              <p class="user-email">{{ user.email }}</p>
              <div v-if="getUserClientBadges(user).length" class="user-client-badges">
                <ion-badge
                  v-for="client in getUserClientBadges(user)"
                  :key="client.key"
                  class="client-badge"
                  :title="client.title"
                >{{ client.label }}</ion-badge>
              </div>
              <div class="user-role-badges">
                <ion-badge
                  v-for="auth in getUserAuthorityBadges(user)"
                  :key="auth.name"
                  class="role-badge"
                  :class="'role-badge--' + auth.kind"
                  :title="auth.description"
                >{{ auth.shortLabel }}</ion-badge>
              </div>
              <div v-if="getUserReleaseBadges(user).length" class="user-release-badges">
                <ion-badge v-for="rel in getUserReleaseBadges(user)" :key="rel.id" class="release-badge" color="orange"
                  :title="rel.label">{{ rel.shortLabel }}</ion-badge>
              </div>
            </ion-label>
            <ion-button v-on:click="setActive(user, false); $event.stopPropagation()" color="success" v-show="user.activated">
              <ion-label class="button-label">Активный</ion-label>
              <ion-icon slot="end" :icon="checkmarkOutline" class="button-icon"></ion-icon>
            </ion-button>
            <ion-button v-on:click="setActive(user, true); $event.stopPropagation()" color="danger" v-show="!user.activated">
              <ion-label class="button-label">Неактивный</ion-label>
              <ion-icon :icon="closeOutline" class="button-icon"></ion-icon>
            </ion-button>
          </ion-item>
          <ion-item class="fake-footer bg-transparent" lines="none"></ion-item>
        </ion-list>
        <div v-if="!usersLoading && totalItems === 0" class="users-empty">Пользователи не найдены.</div>
      </ion-content>

      <div v-if="totalPages > 1" class="users-pagination">
        <ion-button fill="clear" size="small" :disabled="currentPage <= 0 || usersLoading" @click="goToPage(currentPage - 1)">
          Назад
        </ion-button>
        <span class="users-pagination-label">
          Страница {{ currentPage + 1 }} из {{ totalPages }}
        </span>
        <ion-button fill="clear" size="small" :disabled="currentPage >= totalPages - 1 || usersLoading" @click="goToPage(currentPage + 1)">
          Вперёд
        </ion-button>
      </div>

      <ion-modal :is-open="showUserSettings" :breakpoints="[0, 1]" :initialBreakpoint="1"
        class="user-settings-modal"
        @ionModalDidDismiss="showUserSettings = false" @didDissmiss="closeUserSettings()">
        <ion-content class="bg-transparent modal-background user-settings-content">
          <ion-header class="ion-no-border user-settings-header">
            <ion-toolbar class="user-settings-toolbar">
              <div class="liga-float-bar user-settings-float-bar">
                <div class="liga-float-title-pill user-settings-title-pill">
                  <span class="liga-float-title-text">{{ selectedUser[0].firstName }} {{ selectedUser[0].lastName }}</span>
                </div>
                <button type="button" class="liga-float-circle" aria-label="Закрыть" @click="closeUserSettings()">
                  <ion-icon :icon="closeOutline" />
                </button>
              </div>
            </ion-toolbar>
          </ion-header>

          <div class="user-settings-summary">
            <div class="user-settings-field">
              <span class="user-settings-field-label">Логин</span>
              <span class="user-settings-field-value">{{ selectedUser[0].login }}</span>
            </div>
            <div class="user-settings-field user-settings-field--email">
              <span class="user-settings-field-label">E-Mail</span>
              <span class="user-settings-field-value">{{ selectedUser[0].email }}</span>
              <button
                type="button"
                class="liga-float-circle user-settings-copy-btn"
                aria-label="Скопировать email"
                @click="copySelectedUserEmail"
              >
                <ion-icon :icon="copyOutline" />
              </button>
            </div>
            <div class="user-settings-field" :class="{ 'user-settings-field--email': selectedUserPhone }">
              <span class="user-settings-field-label">Телефон</span>
              <span class="user-settings-field-value">{{ selectedUserPhone || 'Не указан' }}</span>
              <button
                v-if="selectedUserPhone"
                type="button"
                class="liga-float-circle user-settings-copy-btn"
                aria-label="Скопировать телефон"
                @click="copySelectedUserPhone"
              >
                <ion-icon :icon="copyOutline" />
              </button>
            </div>
          </div>

          <ion-accordion-group class="user-settings-accordion-group">
            <ion-accordion class="user-settings-accordion" value="common">
              <ion-item slot="header" class="user-settings-acc-header" lines="none">
                <ion-label>Группы прав</ion-label>
              </ion-item>
              <div slot="content" class="user-settings-acc-body">
                <ion-item class="user-settings-row user-settings-row--add" lines="none" v-show="commonAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" mode="ios" @ionChange="onCommonAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="authority in commonAuthorities" :key="authority.name"
                      :value="authority.name">{{ authority.description }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="authority in selectedCommonAuthorities" :key="authority.name" class="user-settings-sliding">
                  <ion-item class="user-settings-row" lines="none">
                    <ion-label>{{ authority.description }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeAuthority(authority)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </div>
            </ion-accordion>

            <ion-accordion class="user-settings-accordion" value="programs">
              <ion-item slot="header" class="user-settings-acc-header" lines="none">
                <ion-label>Допуск к программам</ion-label>
              </ion-item>
              <div slot="content" class="user-settings-acc-body">
                <ion-item class="user-settings-row user-settings-row--add" lines="none" v-show="programAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" mode="ios" @ionChange="onProgramAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="authority in programAuthorities" :key="authority.name"
                      :value="authority.name">{{ authority.description }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="authority in selectedProgramAuthorities" :key="authority.name" class="user-settings-sliding">
                  <ion-item class="user-settings-row" lines="none">
                    <ion-label>{{ authority.description }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeAuthority(authority)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </div>
            </ion-accordion>

            <ion-accordion class="user-settings-accordion" value="sections">
              <ion-item slot="header" class="user-settings-acc-header" lines="none">
                <ion-label>Доступ к разделам</ion-label>
              </ion-item>
              <div slot="content" class="user-settings-acc-body">
                <ion-item class="user-settings-row user-settings-row--add" lines="none" v-show="sectionAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" mode="ios" @ionChange="onSectionAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="authority in sectionAuthorities" :key="authority.name"
                      :value="authority.name">{{ authority.description }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="authority in selectedSectionAuthorities" :key="authority.name" class="user-settings-sliding">
                  <ion-item class="user-settings-row" lines="none">
                    <ion-label>{{ authority.description }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeAuthority(authority)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </div>
            </ion-accordion>

            <ion-accordion class="user-settings-accordion" value="releases">
              <ion-item slot="header" class="user-settings-acc-header" lines="none">
                <ion-label>Допуск к отдельным релизам</ion-label>
              </ion-item>
              <div slot="content" class="user-settings-acc-body">
                <ion-item class="user-settings-row user-settings-row--add" lines="none" v-show="releaseAuthorities.length > 0">
                  <ion-select label="Добавить" :multiple="true" cancel-text="Отмена" mode="ios" @ionChange="onReleaseAuthoritiesChanged($event)"
                    :interface-options="customSelectOptions">
                    <ion-select-option v-for="release in releaseAuthorities" :key="release.id" :value="release">{{
                      release.program ? release.program.programName : '' }}
                      {{ release.releaseName }}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item-sliding v-for="release in selectedUserReleases" :key="release.id" class="user-settings-sliding">
                  <ion-item class="user-settings-row" lines="none">
                    <ion-label>{{ release.program ? release.program.programName : '' }}
                      {{ release.releaseName }}</ion-label>
                  </ion-item>
                  <ion-item-options side="end">
                    <ion-item-option color="danger" @click="removeReleaseAuthority(release)">Удалить</ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-content>
      </ion-modal>

      <ion-modal :is-open="showCreateUser" class="create-user-modal" @didDismiss="closeCreateUserModal()">
        <ion-content class="bg-transparent modal-background">
          <ion-header class="user-settings-header">
            <ion-toolbar>
              <ion-title class="user-settings-header-title">Создать учетную запись</ion-title>
              <ion-buttons slot="end">
                <ion-button @click="closeCreateUserModal()" slot="end" class="user-settings-header-button">
                  <ion-icon :icon="closeOutline" slot="icon-only"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>

          <div class="create-user-form">
            <p class="create-user-hint">
              Пароль будет задан автоматически: по текущей backend-логике это email пользователя в нижнем регистре.
            </p>

            <ion-item class="create-user-field">
              <ion-input label="Логин" label-placement="stacked" v-model="newUser.login" placeholder="ivanov"></ion-input>
            </ion-item>
            <ion-item class="create-user-field">
              <ion-input label="E-Mail" label-placement="stacked" type="email" v-model="newUser.email" placeholder="user@example.com"></ion-input>
            </ion-item>
            <div class="create-user-grid">
              <ion-item class="create-user-field">
                <ion-input label="Имя" label-placement="stacked" v-model="newUser.firstName" placeholder="Иван"></ion-input>
              </ion-item>
              <ion-item class="create-user-field">
                <ion-input label="Фамилия" label-placement="stacked" v-model="newUser.lastName" placeholder="Иванов"></ion-input>
              </ion-item>
            </div>
            <ion-item class="create-user-field">
              <ion-select label="Группы прав" label-placement="stacked" v-model="newUser.authorities" :multiple="true"
                cancel-text="Отмена" mode="ios" :interface-options="customSelectOptions" placeholder="Выберите роли">
                <ion-select-option v-for="authority in creatableAuthorities" :key="authority.name" :value="authority.name">
                  {{ authority.description || authority.name }}
                </ion-select-option>
              </ion-select>
            </ion-item>
            <div class="create-user-actions">
              <ion-button expand="block" class="create-user-save-btn" @click="createUser()" :disabled="creatingUser || !canCreateUser">
                {{ creatingUser ? 'Создание…' : 'Создать учетную запись' }}
              </ion-button>
              <ion-button expand="block" fill="outline" class="create-user-cancel-btn" @click="closeCreateUserModal()">
                Отмена
              </ion-button>
            </div>
          </div>
        </ion-content>
      </ion-modal>

      <ion-modal :can-dismiss="true" @didDismiss="showUserGroups = false" :is-open="showUserGroups"
        class="user-groups-modal user-groups-modal-add-access">
        <div class="user-groups-card-container bg-transparent">
          <ion-card class="add-access-card">
            <ion-card-header class="add-access-header">
              <ion-card-title class="add-access-title">Добавление доступа</ion-card-title>
              <ion-card-subtitle class="add-access-subtitle">Выберите группы прав, релизы и пользователей</ion-card-subtitle>
            </ion-card-header>
            <ion-card-content class="add-access-content">
              <div class="user-groups-select-area add-access-select-tile" @click="showAuthoritiesSelector = true">
                <span class="add-access-tile-label">Группы прав</span>
                <div class="chip-area">
                  <ion-chip v-show="selectedAuthorities.length > 0" v-for="authority in selectedAuthorities"
                    :key="authority.name" class="add-access-chip" color="orange" mode="ios" @click.stop="
                      removeSelectedAuthorities(authority, selectedAuthorities, 'name')">
                    <ion-label>{{ authority.description }}</ion-label>
                    <ion-icon :icon="closeOutline"></ion-icon>
                  </ion-chip>
                  <span v-if="selectedAuthorities.length === 0" class="add-access-placeholder">Нажмите для выбора</span>
                </div>
              </div>
              <div class="user-groups-select-area add-access-select-tile" @click="showReleasesSelector = true">
                <span class="add-access-tile-label">Релизы</span>
                <div class="chip-area">
                  <ion-chip v-show="selectedReleases.length > 0" v-for="release in selectedReleases" :key="release.id"
                    class="add-access-chip" color="orange" mode="ios" @click.stop="
                      removeSelectedReleases(release, selectedReleases, 'id')">
                    <ion-label>{{ release.program ? release.program.programName : '' }} {{ release.releaseName }}</ion-label>
                    <ion-icon :icon="closeOutline"></ion-icon>
                  </ion-chip>
                  <span v-if="selectedReleases.length === 0" class="add-access-placeholder">Нажмите для выбора</span>
                </div>
              </div>
              <div class="user-groups-select-area add-access-select-tile" @click="showUsersSelector = true">
                <span class="add-access-tile-label">Пользователи</span>
                <div class="chip-area">
                  <ion-chip v-show="selectedUsers.length > 0" v-for="user in selectedUsers" :key="user.id"
                    class="add-access-chip" color="orange" mode="ios" @click.stop="removeSelectedUsers(user, selectedUsers, 'id')">
                    <ion-label>{{ user.lastName }} {{ user.firstName }}</ion-label>
                    <ion-icon :icon="closeOutline"></ion-icon>
                  </ion-chip>
                  <span v-if="selectedUsers.length === 0" class="add-access-placeholder">Нажмите для выбора</span>
                </div>
              </div>
            </ion-card-content>
            <div class="user-groups-btn-container add-access-actions">
              <ion-button fill="outline" shape="round" class="add-access-btn-cancel" @click="dismissUserGroups()">
                Отмена
              </ion-button>
              <ion-button fill="solid" shape="round" class="add-access-btn-save" @click="acceptUserGroups()">
                Сохранить
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showAuthoritiesSelector" class="user-groups-modal"
        @ionModalDidDismiss="showAuthoritiesSelector = false">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выбор группы прав</ion-card-title>
            </ion-card-header>
            <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
              @ionInput="addAuthoritiesFilter($event)" :debounce="500"></ion-searchbar>
            <ion-card-content class="list-selector-content">
              <ion-list>
                <ion-item :class="[
                  isSelectedByKey(authority, selectedAuthorities, 'name')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]" @click="
  isSelectedByKey(authority, selectedAuthorities, 'name')
    ? removeSelectedAuthorities(
      authority,
      selectedAuthorities,
      'name'
    )
    : addSelection(authority, selectedAuthorities)
  " v-show="filterAuthorities(authority)" v-for="authority in allAuthorities" :key="authority.name"
                  :value="authority.name">{{ authority.description }}</ion-item>
              </ion-list>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="approveAuthoritiesSelector()" class="user-groups-accept-button">
                Добавить
                {{
                  selectedAuthorities.length > 0
                  ? `(${selectedAuthorities.length})`
                  : ""
                }}
              </ion-button>
              <ion-button @click="dismissAuthoritiesSelector()">
                Отмена
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showReleasesSelector" class="user-groups-modal"
        @ionModalDidDismiss="showReleasesSelector = false">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выбор релиза</ion-card-title>
            </ion-card-header>
            <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
              @ionChange="addReleasesFilter($event)" :debounce="500"></ion-searchbar>
            <ion-card-content class="list-selector-content">
              <ion-list>
                <ion-item :class="[
                  isSelectedByKey(release, selectedReleases, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]" @click="
  isSelectedByKey(release, selectedReleases, 'id')
    ? removeSelectedReleases(release, selectedReleases, 'id')
    : addSelection(release, selectedReleases)
  " v-show="filterReleases(release)" v-for="release in releaseAuthorities" :key="release.id" :value="release">{{
    release.program ? release.program.programName : '' }}
                  {{ release.releaseName }}</ion-item>
              </ion-list>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="approveReleasesSelector()" class="user-groups-accept-button">
                Добавить
                {{
                  selectedReleases.length > 0
                  ? `(${selectedReleases.length})`
                  : ""
                }}
              </ion-button>
              <ion-button @click="dismissReleasesSelector()">
                Отмена
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showUsersSelector" class="user-groups-modal" @ionModalDidDismiss="showUsersSelector = false">
        <div class="user-groups-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выбор пользователей</ion-card-title>
            </ion-card-header>
            <ion-searchbar class="user-search" placeholder="Поиск" inputmode="text" type="text"
              @ionInput="onSearchChange($event)" :debounce="500"></ion-searchbar>
            <ion-card-content class="list-selector-content">
              <ion-list>
                <ion-item :class="[
                  isSelectedByKey(user, selectedUsers, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]" @click="
  isSelectedByKey(user, selectedUsers, 'id')
    ? removeSelectedUsers(user, selectedUsers, 'id')
    : addSelection(user, selectedUsers)
  " v-show="filterUsers(user)" v-for="user in users" :key="user.id" :value="user">{{ user.lastName }}
                  {{ user.firstName }}</ion-item>
              </ion-list>
            </ion-card-content>
            <div class="user-groups-btn-container">
              <ion-button @click="approveUsersSelector()" class="user-groups-accept-button">
                Добавить
                {{
                  selectedUsers.length > 0 ? `(${selectedUsers.length})` : ""
                }}
              </ion-button>
              <ion-button @click="dismissUsersSelector()"> Отмена </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-modal :is-open="showActivityModal" class="users-activity-modal" @didDismiss="closeActivityModal()">
        <ion-content class="bg-transparent modal-background users-activity-content">
          <ion-header class="user-settings-header">
            <ion-toolbar>
              <ion-title class="user-settings-header-title">Активность пользователей</ion-title>
              <ion-buttons slot="end">
                <ion-button @click="closeActivityModal()" class="user-settings-header-button">
                  <ion-icon :icon="closeOutline" slot="icon-only"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>

          <div class="users-activity-body ion-padding">
            <div class="activity-summary">
              <div class="activity-summary-card">
                <span>Активных сейчас</span>
                <strong>{{ activitySessions.length }}</strong>
              </div>
              <div class="activity-summary-card">
                <span>Уникальных пользователей</span>
                <strong>{{ activityUniqueUsers }}</strong>
              </div>
            </div>

            <div class="activity-chart-block">
              <div class="activity-chart-header">
                <h3>Активность по дням</h3>
                <span>уникальные пользователи · {{ activityDays }} дн.</span>
              </div>
              <div v-if="activityLoading" class="activity-loading">Загрузка...</div>
              <div v-else-if="!activityDailyStats.length" class="activity-loading">Нет данных за выбранный период.</div>
              <div v-else class="activity-chart">
                <div v-for="item in activityDailyStats" :key="item.date" class="activity-chart-bar-wrap">
                  <div
                    class="activity-chart-bar"
                    :style="{ height: `${Math.max(8, (item.count / activityChartMax) * 100)}%` }"
                    :title="`${formatActivityDate(item.date)}: ${item.count} уникальных пользователей`"
                  ></div>
                  <span class="activity-chart-count">{{ item.count }}</span>
                  <span class="activity-chart-date">{{ formatActivityShortDate(item.date) }}</span>
                </div>
              </div>
            </div>

            <div class="activity-sessions-block">
              <div class="activity-chart-header">
                <h3>Текущие активные сессии</h3>
                <ion-button fill="clear" size="small" :disabled="activityLoading" @click="loadActivityData()">
                  <ion-icon :icon="refreshOutline"></ion-icon>
                </ion-button>
              </div>
              <div v-if="activityLoading" class="activity-loading">Загрузка...</div>
              <div v-else-if="!activitySessions.length" class="activity-loading">Нет активных сессий.</div>
              <div v-else class="activity-sessions-list">
                <article v-for="session in activitySessions" :key="session.id" class="activity-session-card">
                  <div class="activity-session-top">
                    <strong>{{ formatSessionUser(session) }}</strong>
                    <span>{{ session.userEmail || '—' }}</span>
                  </div>
                  <div class="activity-session-meta">
                    <span>{{ session.deviceName || 'Устройство' }}</span>
                    <span>Создана: {{ formatSessionDateTime(session.createdAt) }}</span>
                    <span>Последняя активность: {{ formatSessionDateTime(session.lastUsedAt || session.createdAt) }}</span>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </ion-content>
      </ion-modal>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { Authority } from "@/model/authority.model";
import { GlobalContext } from "@/model/globalcontext.model";
import { ProgramRelease } from "@/model/programrelease.model";
import { User } from "@/model/user.model";
import { CapacitorHttp } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import {
    IonAccordion,
    IonAccordionGroup,
    IonBadge,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonChip,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonItemOption,
    IonItemOptions,
    IonItemSliding,
    IonLabel,
    IonList,
    IonModal,
    IonPage,
    IonSearchbar,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar,
    alertController,
    toastController,
} from "@ionic/vue";
import AdminService, { IAdminUserSession, IAdminUserSessionDailyStat } from "@/services/admin.service";
import PageHeaderWithMenu from "@/components/PageHeaderWithMenu.vue";
import axios from "axios";
import {
    arrowForward,
    checkmarkOutline,
    closeOutline,
    copyOutline,
    keyOutline,
    personAddOutline,
    refreshOutline,
    statsChartOutline,
} from "ionicons/icons";
import { defineComponent, inject } from "vue";

export default defineComponent({
  name: "Users",
  components: {
    PageHeaderWithMenu,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonPage,
    IonList,
    IonItem,
    IonItemSliding,
    IonItemOptions,
    IonItemOption,
    IonLabel,
    IonButtons,
    IonButton,
    IonBadge,
    IonSearchbar,
    IonIcon,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonModal,
    IonAccordionGroup,
    IonAccordion,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonChip,
  },

  setup() {
    const customSelectOptions: any = {
      cssClass: "role-selector",
    };
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      checkmarkOutline,
      closeOutline,
      copyOutline,
      keyOutline,
      personAddOutline,
      refreshOutline,
      statsChartOutline,
      customSelectOptions,
      isMobile,
      arrowForward,
    };
  },

  data() {
    return {
      headerScrolled: false,
      adminService: new AdminService(),
      notificationsState: false,
      totalItems: 0,
      currentPage: 0,
      pageSize: 25,
      usersLoading: false,
      users: Array<User>(),
      searchBy: "",
      searchAuthoritiesBy: ".",
      searchReleasesBy: ".",
      allAuthorities: Array<Authority>(),
      authoritiesFilter: Array<string>(),
      releasesFilter: Array<number>(),
      showUserSettings: false,
      selectedUser: Array<User>(),
      selectedUserReleases: Array<ProgramRelease>(),
      allReleases: Array<ProgramRelease>(),

      releaseAuthoritiesAdded: Array<number>(),
      showUserGroups: false,

      showAuthoritiesSelector: false,
      selectedAuthorities: Array<Authority>(),

      showReleasesSelector: false,
      selectedReleases: Array<ProgramRelease>(),

      showUsersSelector: false,
      selectedUsers: Array<User>(),
      showCreateUser: false,
      creatingUser: false,
      showActivityModal: false,
      activityLoading: false,
      activitySessions: [] as IAdminUserSession[],
      activityDailyStats: [] as IAdminUserSessionDailyStat[],
      activityDays: 14,
      newUser: {
        login: "",
        email: "",
        firstName: "",
        lastName: "",
        authorities: ["ROLE_USER"],
        activated: true,
        langKey: "ru",
      } as User,
      
      // Защищённые роли, которые нельзя назначать через UI
      protectedRoles: ['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_SYSTEM'],
    };
  },

  computed: {
    selectedUserPhone(): string {
      return (this.selectedUser[0]?.phone || "").trim();
    },
    selectedUserAuthorities(): Array<Authority> {
      const result = new Array<Authority>();
      if (this.selectedUser.length > 0) {
        if (this.selectedUser[0].authorities) {
          this.selectedUser[0].authorities.forEach((a) => {
            const authority = this.getAuthorityByName(a);
            result.push(authority);
          });
        }
      }
      result.sort(function (a, b) {
        const keyA = a.description,
          keyB = b.description;
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
      return result;
    },

    selectedCommonAuthorities(): Array<Authority> {
      return this.selectedUserAuthorities.filter((a) => a.groupId === 1);
    },

    selectedProgramAuthorities(): Array<Authority> {
      return this.selectedUserAuthorities.filter((a) => a.groupId === 2);
    },

    selectedSectionAuthorities(): Array<Authority> {
      return this.selectedUserAuthorities.filter((a) => a.groupId != null && a.groupId > 2);
    },

    commonAuthorities(): Array<Authority> {
      if (!this.allAuthorities) return new Array<Authority>();

      return this.allAuthorities.filter((a) => {
        const foundSelected = this.selectedUserAuthorities.find((ua) => {
          return ua.name === a.name;
        });

        return a.groupId === 1 && foundSelected === undefined;
      });
    },

    programAuthorities(): Array<Authority> {
      if (!this.allAuthorities) return new Array<Authority>();

      return this.allAuthorities.filter((a) => {
        const foundSelected = this.selectedUserAuthorities.find((ua) => {
          return ua.name === a.name;
        });

        return a.groupId === 2 && foundSelected === undefined;
      });
    },

    sectionAuthorities(): Array<Authority> {
      if (!this.allAuthorities) return new Array<Authority>();

      return this.allAuthorities.filter((a) => {
        const foundSelected = this.selectedUserAuthorities.find((ua) => {
          return ua.name === a.name;
        });

        return a.groupId != null && a.groupId > 2 && foundSelected === undefined;
      });
    },

    releaseAuthorities(): Array<ProgramRelease> {
      if (!this.allReleases) return new Array<ProgramRelease>();

      return this.allReleases
        .filter((r) => {
          const foundSelected = this.selectedUserReleases.find((ur) => {
            return ur.id === r.id;
          });

          return foundSelected === undefined;
        })
        .sort((a, b) => {
          const aParts = (a.releaseName || "").split(" ");
          const bParts = (b.releaseName || "").split(" ");
          const aName = aParts.slice(0, aParts.length - 1).join(" ");
          const aNum = aParts[aParts.length - 1];
          const bName = bParts.slice(0, bParts.length - 1).join(" ");
          const bNum = bParts[bParts.length - 1];

          return aNum.localeCompare(bNum) && aName.localeCompare(bName);
        })
        .reverse();
    },
    creatableAuthorities(): Array<Authority> {
      if (!this.allAuthorities) return new Array<Authority>();
      return this.allAuthorities
        .filter((a) => !this.protectedRoles.includes(a.name))
        .sort((a, b) => (a.description || a.name).localeCompare(b.description || b.name));
    },
    canCreateUser(): boolean {
      return !!(
        this.newUser.login?.trim() &&
        this.newUser.email?.trim() &&
        this.newUser.authorities &&
        this.newUser.authorities.length > 0
      );
    },
    totalPages(): number {
      return Math.max(1, Math.ceil(this.totalItems / this.pageSize));
    },
    activityChartMax(): number {
      if (!this.activityDailyStats.length) return 1;
      return Math.max(...this.activityDailyStats.map((item) => item.count), 1);
    },
    activityUniqueUsers(): number {
      const ids = new Set(
        this.activitySessions
          .map((session) => session.userId)
          .filter((id): id is number => id != null)
      );
      return ids.size;
    },
  },

  mounted() {
    this.requestUsers();
    this.getAllAuthorities();
    this.getAllReleases();
  },

  ionViewDidEnter() {
    this.requestUsers();
    this.getAllAuthorities();
  },

  watch: {
    '$store.getters.rolesUpdatedAt'() {
      this.requestUsers();
      this.getAllAuthorities();
    },
    authoritiesFilter() {
      this.currentPage = 0;
      this.requestUsers();
    },
    releasesFilter() {
      this.currentPage = 0;
      this.requestUsers();
    },
  },

  methods: {
    onContentScroll(e: Event) {
      const ev = e as CustomEvent<{ scrollTop?: number }>;
      this.headerScrolled = (ev.detail?.scrollTop ?? 0) > 30;
    },
    onSearchChange(ev: any) {
      this.searchBy = ev.detail.value?.trim() || "";
      this.currentPage = 0;
      this.requestUsers();
    },

    goToPage(page: number) {
      const nextPage = Math.max(0, Math.min(page, this.totalPages - 1));
      if (nextPage === this.currentPage) return;
      this.currentPage = nextPage;
      this.requestUsers();
    },

    async openActivityModal() {
      this.showActivityModal = true;
      await this.loadActivityData();
    },

    closeActivityModal() {
      this.showActivityModal = false;
    },

    async loadActivityData() {
      this.activityLoading = true;
      try {
        const [sessions, stats] = await Promise.all([
          this.adminService.getAdminUserSessions(),
          this.adminService.getAdminUserSessionDailyStats(this.activityDays),
        ]);
        this.activitySessions = sessions;
        this.activityDailyStats = stats;
      } catch (e) {
        console.error("loadActivityData", e);
        this.activitySessions = [];
        this.activityDailyStats = [];
      } finally {
        this.activityLoading = false;
      }
    },

    formatSessionUser(session: IAdminUserSession): string {
      const name = `${session.userLastName || ""} ${session.userFirstName || ""}`.trim();
      return name || session.userLogin || "Пользователь";
    },

    formatSessionDateTime(value?: string | null): string {
      if (!value) return "—";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "—";
      return date.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    formatActivityDate(value: string): string {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString("ru-RU");
    },

    formatActivityShortDate(value: string): string {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value.slice(5);
      return date.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit" });
    },

    async copySelectedUserEmail() {
      await this.copyTextToClipboard(this.selectedUser[0]?.email?.trim() || "", "Email");
    },

    async copySelectedUserPhone() {
      await this.copyTextToClipboard(this.selectedUserPhone, "Телефон");
    },

    async copyTextToClipboard(value: string, label: string) {
      if (!value) return;
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = value;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        const toast = await toastController.create({
          message: `${label} скопирован`,
          duration: 1800,
          position: "top",
          color: "success",
        });
        await toast.present();
      } catch (e) {
        console.error("copy text", e);
        const toast = await toastController.create({
          message: `Не удалось скопировать ${label.toLowerCase()}`,
          duration: 2200,
          position: "top",
          color: "warning",
        });
        await toast.present();
      }
    },

    openCreateUserModal() {
      this.resetNewUser();
      this.showCreateUser = true;
    },

    closeCreateUserModal() {
      this.showCreateUser = false;
      this.creatingUser = false;
    },

    resetNewUser() {
      this.newUser = {
        login: "",
        email: "",
        firstName: "",
        lastName: "",
        authorities: ["ROLE_USER"],
        activated: true,
        langKey: "ru",
      } as User;
    },

    async createUser() {
      if (!this.canCreateUser || this.creatingUser) {
        return;
      }
      this.creatingUser = true;
      try {
        const payload: Partial<User> = {
          login: this.newUser.login?.trim(),
          email: this.newUser.email?.trim(),
          firstName: this.newUser.firstName?.trim(),
          lastName: this.newUser.lastName?.trim(),
          activated: true,
          langKey: this.newUser.langKey || "ru",
          authorities: [...(this.newUser.authorities || ["ROLE_USER"])],
        };
        await this.adminService.createAdminUser(payload);
        const toast = await toastController.create({
          message: "Учетная запись создана",
          duration: 2200,
          position: "top",
          color: "success",
        });
        await toast.present();
        this.closeCreateUserModal();
        this.resetNewUser();
        await this.requestUsers();
      } catch (e: any) {
        console.error("createUser", e);
        const responseMessage = e?.response?.data?.message || e?.message || "";
        const message = responseMessage.includes("emailexists")
          ? "Пользователь с таким e-mail уже существует"
          : responseMessage.includes("userexists")
            ? "Пользователь с таким логином уже существует"
            : "Ошибка создания учетной записи";
        const toast = await toastController.create({
          message,
          duration: 3000,
          position: "top",
          color: "danger",
        });
        await toast.present();
      } finally {
        this.creatingUser = false;
      }
    },

    acceptUserGroups() {
      this.showUserGroups = false;

      this.saveUserGroupsAuthorities();
      this.saveUserGroupsReleases();
    },

    dismissUserGroups() {
      this.showUserGroups = false;
      this.selectedAuthorities = [];
      this.selectedReleases = [];
      this.selectedUsers = [];
    },

    addAuthoritiesFilter(ev: any) {
      if (ev.detail.value.trim() === "") {
        this.searchAuthoritiesBy = ".";
      } else {
        this.searchAuthoritiesBy = ev.detail.value.trim();
      }
    },

    addReleasesFilter(ev: any) {
      if (ev.detail.value.trim() === "") {
        this.searchReleasesBy = ".";
      } else {
        this.searchReleasesBy = ev.detail.value.trim();
      }
    },

    filterUsers(user: User) {
      if (!user || !user.lastName || !user.firstName) return true;

      if (!this.searchBy) {
        return true;
      }

      const searchByRegExp = new RegExp(this.searchBy.toLowerCase());
      let result = searchByRegExp.test(
        user.lastName.toLowerCase() + user.firstName.toLowerCase()
      );

      if (result && this.authoritiesFilter.length > 0) {
        result =
          typeof user.authorities !== "undefined" &&
          user.authorities.some((authority) => {
            return this.authoritiesFilter.includes(authority);
          });
      }

      if (result && this.releasesFilter.length > 0) {
        result =
          typeof user.releases !== "undefined" &&
          user.releases.length > 0 &&
          user.releases.some((releaseId: number) => this.releasesFilter.includes(releaseId));
      }

      return result;
    },

    onReleasesFilterChange(ev: any) {
      const val = ev && ev.detail && ev.detail.value;
      this.releasesFilter = Array.isArray(val) ? [...val] : [];
    },

    filterAuthorities(authority: Authority) {
      if (!authority || !authority.description) return true;

      const searchByRegExp = new RegExp(this.searchAuthoritiesBy.toLowerCase());
      return searchByRegExp.test(authority.description.toLowerCase());
    },

    filterReleases(release: any) {
      if (!release || !release.releaseName) return true;

      const searchByRegExp = new RegExp(this.searchReleasesBy.toLowerCase());
      return searchByRegExp.test(
        `${release.program ? release.program.programName : ''} ${release.releaseName}`.toLowerCase()
      );
    },

    clearFilter(filterName: string) {
      if ("authorities" === filterName) {
        this.authoritiesFilter = new Array<string>();
      }
      if ("releases" === filterName) {
        this.releasesFilter = new Array<number>();
      }
    },

    authorityBadgeKind(groupId?: number | null): 'common' | 'program' | 'section' | 'other' {
      if (groupId === 1) return 'common';
      if (groupId === 2) return 'program';
      if (groupId != null && groupId > 2) return 'section';
      return 'other';
    },

    formatAuthorityShortLabel(description: string, name: string): string {
      const desc = (description || '').trim();
      const quoted = desc.match(/«([^»]+)»/);
      if (quoted?.[1]) return quoted[1].trim();

      let short = desc
        .replace(/^Доступ к разделу\s*/i, '')
        .replace(/^Доступ к программе\s*/i, '')
        .replace(/^Доступ к\s*/i, '')
        .replace(/^Роль\s*/i, '')
        .trim();
      if (!short) short = name.replace(/^ROLE_/, '').replace(/_/g, ' ');
      if (short.length <= 18) return short;
      return short.slice(0, 16) + '…';
    },

    formatClientPlatform(platform?: string | null): string {
      switch ((platform || '').toLowerCase()) {
        case 'ios':
          return 'iOS';
        case 'android':
          return 'Android';
        case 'huawei':
          return 'Huawei';
        case 'web':
          return 'Web';
        default:
          return platform || 'Клиент';
      }
    },

    getUserClientBadges(user: User): Array<{ key: string; label: string; title: string }> {
      const infos = user.clientInfos;
      if (!infos || !infos.length) return [];
      return infos.map((info, index) => {
        const platform = this.formatClientPlatform(info.platform);
        const version = (info.appVersion || '').trim();
        const build = (info.appBuild || '').trim();
        const label = version ? `${platform} ${version}` : platform;
        const title = build ? `${label} (${build})` : label;
        return {
          key: `${info.platform || 'x'}-${version || 'x'}-${build || index}`,
          label,
          title,
        };
      });
    },

    getUserAuthorityBadges(
      user: User
    ): Array<{ name: string; description: string; shortLabel: string; kind: 'common' | 'program' | 'section' | 'other' }> {
      if (!user.authorities || user.authorities.length === 0) return [];
      const kindOrder = { common: 0, program: 1, section: 2, other: 3 };
      return user.authorities
        .filter((authName) => authName !== 'ROLE_USER')
        .map((authName) => {
          const auth = this.getAuthorityByName(authName);
          const desc = auth.description || auth.name;
          const kind = this.authorityBadgeKind(auth.groupId);
          return {
            name: authName,
            description: desc,
            shortLabel: this.formatAuthorityShortLabel(desc, authName),
            kind,
          };
        })
        .sort((a, b) => {
          const byKind = kindOrder[a.kind] - kindOrder[b.kind];
          if (byKind !== 0) return byKind;
          return a.shortLabel.localeCompare(b.shortLabel, 'ru');
        });
    },

    getUserReleaseBadges(user: User): Array<{ id: number; label: string; shortLabel: string }> {
      if (!user.releases || user.releases.length === 0 || !this.allReleases || !this.allReleases.length) return [];
      return user.releases
        .map((releaseId) => {
          const r = this.allReleases.find((rel) => rel.id === releaseId);
          if (!r) return null;
          const label = `${r.program ? r.program.programName : ""} ${r.releaseName || ""}`.trim();
          const shortLabel = label.length > 14 ? label.slice(0, 12) + "…" : label;
          return { id: releaseId, label, shortLabel };
        })
        .filter((x): x is { id: number; label: string; shortLabel: string } => x != null);
    },

    async refreshRolesCache() {
      try {
        await this.adminService.refreshRolesCache();
        const toast = await toastController.create({
          message: "Кеш ролей обновлён",
          duration: 2000,
          position: "top",
          color: "success",
        });
        await toast.present();
        this.requestUsers();
      } catch (e) {
        console.error("refreshRolesCache", e);
        const toast = await toastController.create({
          message: "Ошибка обновления кеша ролей",
          duration: 3000,
          position: "top",
          color: "danger",
        });
        await toast.present();
      }
    },

    async showProtectedRoleWarning(roleName: string) {
      const toast = await toastController.create({
        message: `Назначение ${roleName} запрещено из соображений безопасности. Обратитесь к системному администратору.`,
        duration: 4000,
        position: "top",
        color: "danger",
      });
      await toast.present();
    },

    addSelection(item: any, list: Array<any>) {
      list.push(item);
    },

    removeSelection(item: any, list: Array<any>, byKey: any) {
      return list.filter((i) => {
        return i[byKey] !== item[byKey];
      });
    },

    removeSelectedAuthorities(item: any, list: Array<any>, byKey: any) {
      this.selectedAuthorities = this.removeSelection(item, list, byKey);
    },

    removeSelectedReleases(item: any, list: Array<any>, byKey: any) {
      this.selectedReleases = this.removeSelection(item, list, byKey);
    },

    removeSelectedUsers(item: any, list: Array<any>, byKey: any) {
      this.selectedUsers = this.removeSelection(item, list, byKey);
    },

    isSelectedByKey(item: any, list: Array<any>, byKey: any) {
      return (
        undefined !==
        list.find((i) => {
          return i[byKey] === item[byKey];
        })
      );
    },

    dismissAuthoritiesSelector() {
      this.showAuthoritiesSelector = false;
      this.selectedAuthorities = new Array<Authority>();
    },

    approveAuthoritiesSelector() {
      this.showAuthoritiesSelector = false;
    },

    dismissReleasesSelector() {
      this.showReleasesSelector = false;
      this.selectedReleases = new Array<ProgramRelease>();
    },

    approveReleasesSelector() {
      this.showReleasesSelector = false;
    },

    dismissUsersSelector() {
      this.showUsersSelector = false;
      this.selectedUsers = new Array<User>();
    },

    approveUsersSelector() {
      this.showUsersSelector = false;
    },

    async requestUsers() {
      this.usersLoading = true;
      try {
        let page = this.currentPage;
        const options = {
          search: this.searchBy,
          authorityFilter: this.authoritiesFilter,
          releaseFilter: this.releasesFilter,
        };
        let result = await this.adminService.getAdminUsersPage(page, this.pageSize, options);
        const maxPage = Math.max(0, Math.ceil(result.total / this.pageSize) - 1);
        if (page > maxPage) {
          page = maxPage;
          this.currentPage = maxPage;
          result = await this.adminService.getAdminUsersPage(page, this.pageSize, options);
        }
        this.users = result.users;
        this.totalItems = result.total;
      } catch (e) {
        console.error("error loading users", e);
        if (!this.isMobile) {
          this.$router.replace("/badconnection");
        }
      } finally {
        this.usersLoading = false;
      }
    },

    async setActive(user: User, active: boolean) {
      user.activated = active;
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const data = {
          id: user.id,
          login: user.login,
          email: user.email,
          activated: user.activated,
        };

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/admin/users/activate`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: data,
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios.put("api/admin/users", user).catch(() => {
          this.$router.replace("/badconnection");
        });
      }
    },

    async getAllAuthorities() {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/authorities-full`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.allAuthorities = response.data;
            this.allAuthorities.sort(function (a, b) {
              const keyA = a.description,
                keyB = b.description;
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch((ex) => {
            console.log("error loading authorities", ex);
          });
      } else {
        axios
          .get("api/authorities-full")
          .then((response) => {
            this.allAuthorities = response.data;
            this.allAuthorities.sort(function (a, b) {
              const keyA = a.description,
                keyB = b.description;
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    async getAllReleases() {
      const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/releases`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.allReleases = response.data;
            // this.allReleases.sort(function (a, b) {
            //   const keyA =
            //     `${a.program.id > 0
            //       ? a.program.programName
            //       : ""
            //     } ${((a.releaseName && a.releaseName.length) || 0) < 2
            //       ? "0" + a.releaseName
            //       : a.releaseName
            //     }` || "",
            //     keyB =
            //       `${b.program.id > 0
            //         ? b.program.programName
            //         : ""
            //       } ${((b.releaseName && b.releaseName.length) || 0) < 2
            //         ? "0" + b.releaseName
            //         : b.releaseName
            //       }` || "";
            //   if (keyA < keyB) return -1;
            //   if (keyA > keyB) return 1;
            //   return 0;
            // });
          })
          .catch((ex) => {
            console.log("error loading releases", ex);
          });
    },

    async getUserReleases(user: User) {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/user/releases/${user.id}`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
        };

        await CapacitorHttp.get(options)
          .then((response) => {
            this.selectedUserReleases = response.data;
            this.selectedUserReleases.sort(function (a, b) {
              const keyA =
                `${a.program.id > 0
                  ? a.program.programName
                  : ""
                } ${((a.releaseName && a.releaseName.length) || 0) < 2
                  ? "0" + a.releaseName
                  : a.releaseName
                }` || "",
                keyB =
                  `${b.program.id > 0
                    ? b.program.programName
                    : ""
                  } ${((b.releaseName && b.releaseName.length) || 0) < 2
                    ? "0" + b.releaseName
                    : b.releaseName
                  }` || "";
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch((ex) => {
            console.log("error loading user releases", ex);
          });
      } else {
        axios
          .get(`api/user/releases/${user.id}`)
          .then((response) => {
            this.selectedUserReleases = response.data;
            this.selectedUserReleases.sort(function (a, b) {
              const keyA =
                `${a.program.id > 0
                  ? a.program.programName
                  : ""
                } ${((a.releaseName && a.releaseName.length) || 0) < 2
                  ? "0" + a.releaseName
                  : a.releaseName
                }` || "",
                keyB =
                  `${b.program.id > 0
                    ? b.program.programName
                    : ""
                  } ${((b.releaseName && b.releaseName.length) || 0) < 2
                    ? "0" + b.releaseName
                    : b.releaseName
                  }` || "";
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    onCommonAuthoritiesChanged(event: any) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();
      
      // Фильтруем административные роли
      const newAuthorities = event.target.value.filter((a: string) => {
        if (this.protectedRoles.includes(a)) {
          this.showProtectedRoleWarning(a);
          return false;
        }
        return true;
      });
      
      newAuthorities.forEach((a: string) => {
        const found = currentUserAuthorities.find((ua) => {
          return ua === a;
        });

        if (found === undefined) {
          currentUserAuthorities.push(a);
        }
      });

      this.selectedUser[0].authorities = currentUserAuthorities;

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    onProgramAuthoritiesChanged(event: any) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();
      
      // Фильтруем административные роли
      const newAuthorities = event.target.value.filter((a: string) => {
        if (this.protectedRoles.includes(a)) {
          this.showProtectedRoleWarning(a);
          return false;
        }
        return true;
      });
      
      newAuthorities.forEach((a: string) => {
        const found = currentUserAuthorities.find((ua) => {
          return ua === a;
        });

        if (found === undefined) {
          currentUserAuthorities.push(a);
        }
      });

      this.selectedUser[0].authorities = currentUserAuthorities;

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    onSectionAuthoritiesChanged(event: any) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();

      const newAuthorities = event.target.value.filter((a: string) => {
        if (this.protectedRoles.includes(a)) {
          this.showProtectedRoleWarning(a);
          return false;
        }
        return true;
      });

      newAuthorities.forEach((a: string) => {
        const found = currentUserAuthorities.find((ua) => {
          return ua === a;
        });

        if (found === undefined) {
          currentUserAuthorities.push(a);
        }
      });

      this.selectedUser[0].authorities = currentUserAuthorities;

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    onReleaseAuthoritiesChanged(event: any) {
      event.target.value.forEach((release: ProgramRelease) => {
        const found = this.selectedUserReleases.find((userRelease) => {
          return userRelease.id === release.id;
        });

        if (found === undefined) {
          this.selectedUserReleases.push(release);
        }
      });

      this.selectedUser[0].releases = this.selectedUserReleases.map((r) => {
        return r.id || 0;
      });
      this.saveUserReleases(this.selectedUser[0]);
    },

    removeAuthority(authority: Authority) {
      const currentUserAuthorities =
        this.selectedUser[0].authorities || new Array<string>();
      this.selectedUser[0].authorities = currentUserAuthorities.filter((ua) => {
        return ua !== authority.name;
      });

      this.saveUserAuthorities(this.selectedUser[0]);
    },

    removeReleaseAuthority(release: ProgramRelease) {
      this.selectedUserReleases = this.selectedUserReleases.filter(
        (userRelease) => {
          return userRelease.id !== release.id;
        }
      );

      this.selectedUser[0].releases = this.selectedUserReleases.map((r) => {
        return r.id || 0;
      });
      this.saveUserReleases(this.selectedUser[0]);
    },

    saveUserGroupsAuthorities() {
      if (this.selectedUsers.length < 1 || this.selectedAuthorities.length < 1)
        return;

      // Проверяем наличие защищённых ролей
      const hasProtectedRoles = this.selectedAuthorities.some(sa => 
        this.protectedRoles.includes(sa.name)
      );
      
      if (hasProtectedRoles) {
        this.showProtectedRoleWarning('административных ролей');
        return;
      }

      this.selectedUsers.forEach((user) => {
        const currentAuthorities = user.authorities || new Array<string>();
        this.selectedAuthorities.forEach((sa) => {
          if (
            undefined ==
            currentAuthorities.find((ca) => {
              return ca === sa.name;
            })
          ) {
            currentAuthorities.push(sa.name);
          }
        });
        user.authorities = currentAuthorities;
        this.saveUserAuthorities(user);
      });
    },

    saveUserGroupsReleases() {
      if (this.selectedUsers.length < 1 || this.selectedReleases.length < 1)
        return;

      this.selectedUsers.forEach((user) => {
        const currentReleases = user.releases || new Array<number>();
        this.selectedReleases.forEach((sr) => {
          if (
            sr.id &&
            undefined ==
            currentReleases.find((cr) => {
              return cr === sr.id;
            })
          ) {
            currentReleases.push(sr.id);
          }
        });
        user.releases = currentReleases;
        this.saveUserReleases(user);
      });
    },

    async saveUserAuthorities(user: User) {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/admin/users/authorities`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: JSON.stringify(user),
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios.post("api/admin/users/authorities", user).catch(() => {
          this.$router.replace("/badconnection");
        });
      }
    },

    async saveUserReleases(user: User) {
      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/admin/users/releases`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: JSON.stringify(user),
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios.post("api/admin/users/releases", user).catch(() => {
          this.$router.replace("/badconnection");
        });
      }
    },

    getAuthorityByName(authorityName: string): Authority {
      const foundByName = this.allAuthorities.find((a) => {
        return a.name === authorityName;
      });
      if (typeof foundByName !== "undefined") {
        return foundByName;
      }

      return new Authority(authorityName);
    },

    openUserSettings(user: User) {
      this.showUserSettings = true;
      this.selectedUser = new Array<User>();
      this.selectedUser.push(user);
      this.getUserReleases(user);
    },

    closeUserSettings() {
      this.showUserSettings = false;
      this.requestUsers();
    },

    openUserGroupsSelector() {
      this.selectedUsers = [];
      this.selectedReleases = [];
      this.selectedAuthorities = [];
      this.showUserGroups = true;
    },

    async confirmSync() {
      const alert = await alertController.create({
        header: "Подтверждение!",
        message: `Внимание: будет выполнена синхронизация с внешней таблицей, что приведет к перезаписи данных приложения`,
        buttons: [
          {
            text: "Отмена",
            role: "cancel",
            cssClass: "secondary",
            id: "cancel-button",
          },
          {
            text: "Далее",
            id: "confirm-button",
            handler: () => {
              this.syncUsers();
            },
          },
        ],
      });
      return alert.present();
    },

    async syncUsers() {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/google/sync-accounts`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        readTimeout: 60000,
      };

      await CapacitorHttp.post(options).catch(() => {
        this.$router.replace("/badconnection");
      });
    },
  },
});
</script>

<style scoped>
h1 {
  letter-spacing: 0.08em;
}

.button-icon {
  color: var(--liga-chrome-text);
}

.button-label {
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.8em;
  font-weight: bold;
  color: var(--liga-chrome-text);
}

.fab-icon {
  --color: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
}

.user-item {
  --background: var(--liga-surface);
  border-top: 1px solid var(--liga-surface-border);
  border-bottom: 1px solid var(--liga-surface-border);
  margin-bottom: 10px;
  --min-height: 20px;
  color: var(--liga-chrome-text);
}

.user-name, .user-email {
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 1em;
  color: var(--liga-chrome-text);
}

.user-email {
  font-weight: 500;
  font-size: .8em;
  color: var(--liga-chrome-text-muted);
}

.user-search {
  --background: var(--liga-float-glass-bg);
  --placeholder-opacity: 0.5;
  --color: var(--liga-chrome-text);
  --placeholder-color: var(--liga-chrome-text-muted);
  --border-radius: 20px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.fake-footer {
  height: 40vh;
}

/* Панель над списком: всего + обновить + Кеш ролей + Группы */
.users-total-above-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 6px 16px 8px;
  flex-shrink: 0;
  border-top: 1px solid var(--liga-surface-border);
  background: var(--liga-surface);
}
.users-total-label {
  font-size: 0.875rem;
  color: var(--liga-chrome-text);
  font-weight: 500;
}
.users-total-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.users-refresh-btn {
  --color: var(--ion-color-orange);
  --padding-start: 6px;
  --padding-end: 6px;
  margin: 0;
  min-height: 32px;
}
.users-panel-btn {
  min-height: 32px;
  font-size: 0.8rem;
  font-weight: 600;
  --border-radius: 16px;
  margin: 0;
}
.users-panel-btn ion-icon {
  margin-right: 4px;
  font-size: 0.95em;
}
.users-panel-btn-cache {
  --background: var(--ion-color-orange) !important;
  --background-activated: var(--ion-color-orange-tint) !important;
  --background-hover: var(--ion-color-orange-tint) !important;
  --color: var(--liga-chrome-text) !important;
  --color-activated: #fff !important;
  --color-hover: #fff !important;
}
.users-panel-btn-create {
  --background: var(--ion-color-orange) !important;
  --background-activated: var(--ion-color-orange-tint) !important;
  --background-hover: var(--ion-color-orange-tint) !important;
  --color: var(--liga-chrome-text) !important;
  --color-activated: #fff !important;
  --color-hover: #fff !important;
}
.users-panel-btn-groups {
  --border-color: var(--ion-color-orange) !important;
  --border-width: 2px !important;
  --color: var(--ion-color-orange) !important;
  --color-activated: #fff !important;
  --color-hover: #fff !important;
  --background-activated: var(--ion-color-orange) !important;
  --background-hover: rgba(235, 89, 82, 0.15) !important;
}

/* Мобильная версия: список пользователей занимает большую часть экрана */
@media (max-width: 768px) {
  .users-page-mobile {
    display: flex;
    flex-direction: column;
    --overflow: hidden;
  }
  .users-page-mobile .users-top-section {
    flex-shrink: 0;
    padding-bottom: 6px;
  }
  .users-page-mobile .users-total-above-list {
    padding: 6px 12px 8px;
    gap: 6px;
  }
  .users-page-mobile .users-total-label {
    font-size: 0.8rem;
  }
  .users-page-mobile .users-panel-btn {
    min-height: 30px;
    font-size: 0.75rem;
    padding: 0 8px;
  }
  .users-page-mobile .users-panel-btn ion-icon {
    margin-right: 2px;
    font-size: 0.9em;
  }
  .users-page-mobile .user-search {
    margin-bottom: 4px;
  }
  .users-page-mobile .filter-field-clear-button {
    margin-bottom: 4px;
  }
  .users-page-mobile .users-list-scroll {
    flex: 1 1 0;
    min-height: 0;
    contain: layout size style;
  }
}

.filter-field {
  width: 100%;
  color: var(--liga-chrome-text);
  --background-activated: black !important;
  --background: transparent;
}

.filter-field-clear-button {
  color: var(--ion-color-orange) !important;
  margin-bottom: 5px;
  --background: transparent;
  border-top: 1px solid var(--liga-surface-border);
  border-bottom: 1px solid var(--liga-surface-border);
}
/* Крестик сброса фильтра — оранжевый (иконка в слоте ion-item) */
:deep(.filter-field-clear-button ion-icon) {
  color: var(--ion-color-orange) !important;
}

.user-settings-header-title {
  color: var(--liga-chrome-text);
  font-size: 1.05rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-settings-header-button {
  color: var(--liga-chrome-text) !important;
  --background-activated: transparent !important;
}

.user-settings-section-list {
  height: 50vh;
}

.user-settings-section-header {
  font-weight: bold;
  color: var(--ion-color-orange);
}

.user-settings-section-list ion-item {
  margin-bottom: 5px;
  border-top: 1px solid var(--liga-surface-border);
  border-bottom: 1px solid var(--liga-surface-border);
  --background: var(--liga-surface);
  color: var(--liga-chrome-text);
}

/* Окно редактирования пользователя */
.user-settings-modal {
  --background: var(--liga-float-glass-bg-strong) !important;
  --ion-background-color: var(--liga-float-glass-bg-strong) !important;
}
.user-settings-modal::part(content) {
  background: var(--liga-float-glass-bg-strong) !important;
  border-radius: 18px 18px 0 0;
  border: 1px solid var(--liga-float-glass-border);
  backdrop-filter: var(--liga-float-glass-blur);
  -webkit-backdrop-filter: var(--liga-float-glass-blur);
}
.modal-background,
.user-settings-content {
  background: var(--liga-page-bg) !important;
  --background: var(--liga-page-bg) !important;
}

.user-settings-toolbar {
  --background: transparent;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 8px;
  --border-width: 0;
  --min-height: 56px;
}

.user-settings-float-bar {
  padding: 6px 12px 8px;
}

.user-settings-title-pill {
  justify-content: flex-start;
  text-align: left;
}

.user-settings-title-pill .liga-float-title-text {
  text-align: left;
  font-weight: 700;
}

.user-settings-float-bar .liga-float-circle {
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: var(--liga-chrome-text);
  flex-shrink: 0;
}

.user-settings-float-bar .liga-float-circle ion-icon {
  font-size: 22px;
}

.user-settings-summary {
  display: grid;
  gap: 8px;
  margin: 4px 12px 12px;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--liga-float-glass-border);
}

.user-settings-field {
  display: grid;
  grid-template-columns: minmax(72px, 0.3fr) minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-height: 36px;
}

.user-settings-field--email {
  grid-template-columns: minmax(72px, 0.3fr) minmax(0, 1fr) 40px;
}

.user-settings-field-label {
  color: var(--liga-chrome-text-muted);
  font-size: 0.78rem;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.user-settings-field-value {
  color: var(--liga-chrome-text);
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.25;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.user-settings-copy-btn {
  width: 36px;
  height: 36px;
  color: var(--liga-chrome-text);
}

.user-settings-copy-btn ion-icon {
  font-size: 18px;
}

.user-settings-accordion-group {
  padding: 0 12px 24px;
  background: transparent;
}

.user-settings-accordion {
  margin-bottom: 10px;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
}

.user-settings-accordion::part(header),
.user-settings-accordion::part(content) {
  background: transparent;
}

.user-settings-accordion::part(expand-icon) {
  color: var(--liga-chrome-text-muted);
  font-size: 1.1rem;
  margin-inline-end: 10px;
}

.user-settings-acc-header {
  --background: transparent;
  --background-hover: rgba(255, 255, 255, 0.04);
  --background-activated: rgba(255, 255, 255, 0.06);
  --padding-start: 14px;
  --padding-end: 4px;
  --min-height: 52px;
  --color: var(--liga-chrome-text);
  font-weight: 650;
}

.user-settings-acc-header ion-label {
  color: var(--liga-chrome-text) !important;
  font-weight: 650;
  font-size: 0.95rem;
}

.user-settings-acc-body {
  padding: 0 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user-settings-sliding {
  border-radius: 12px;
  overflow: hidden;
}

.user-settings-row {
  --background: var(--liga-surface);
  --background-hover: var(--liga-float-glass-bg);
  --background-activated: var(--liga-float-glass-bg-strong);
  --border-color: transparent;
  --padding-start: 14px;
  --padding-end: 12px;
  --min-height: 48px;
  --color: var(--liga-chrome-text);
  border-radius: 12px;
  border: 1px solid var(--liga-float-glass-border);
  margin: 0;
}

.user-settings-row::part(native) {
  border-radius: 12px;
}

.user-settings-row ion-label {
  color: var(--liga-chrome-text) !important;
  font-weight: 550;
  font-size: 0.92rem;
}

.user-settings-row--add {
  --background: var(--liga-surface);
  border-style: dashed;
  border-color: var(--liga-float-glass-border);
}

.user-settings-row--add ion-select {
  width: 100%;
  max-width: 100%;
  --color: var(--liga-chrome-text);
}

.create-user-modal {
  --background: var(--liga-float-glass-bg-strong) !important;
  --ion-background-color: var(--liga-float-glass-bg-strong) !important;
}

.create-user-modal::part(content) {
  background: var(--liga-float-glass-bg-strong) !important;
}

.create-user-form {
  max-width: 720px;
  margin: 0 auto;
  padding: 18px;
}

.create-user-hint {
  margin: 0 0 16px;
  color: var(--liga-chrome-text-muted);
  line-height: 1.35;
  font-size: 0.9rem;
}

.create-user-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.create-user-field {
  --background: var(--liga-surface) !important;
  --background-activated: var(--liga-float-glass-bg) !important;
  --background-hover: var(--liga-float-glass-bg) !important;
  --border-radius: 12px;
  --color: var(--liga-chrome-text);
  --min-height: 58px;
  border-radius: 12px;
  margin-bottom: 10px;
}

.create-user-field ion-input,
.create-user-field ion-select {
  --color: var(--liga-chrome-text);
  --placeholder-color: var(--liga-chrome-text-muted);
}

.create-user-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 8px;
}

.create-user-save-btn {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --background-hover: var(--ion-color-orange-tint);
  --color: var(--liga-chrome-text);
  font-weight: 700;
}

.create-user-cancel-btn {
  --border-color: var(--ion-color-orange);
  --color: var(--ion-color-orange);
  font-weight: 700;
}

@media (max-width: 768px) {
  .create-user-form {
    padding: 14px;
  }

  .create-user-grid,
  .create-user-actions {
    grid-template-columns: 1fr;
  }
}

.common-field {
  --background: var(--liga-float-glass-bg-strong);
  color: var(--liga-chrome-text);
}

ion-item {
  color: var(--liga-chrome-text);
  --color-focused: white;
  --color-hover: white;
  --color-activated: #434343;
}

.user-client-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 5px;
  max-width: 100%;
}

.user-client-badges .client-badge,
:deep(.user-client-badges ion-badge.client-badge) {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 2px 7px;
  --padding-start: 7px;
  --padding-end: 7px;
  border-radius: 999px;
  background: rgba(120, 190, 255, 0.18) !important;
  color: rgba(210, 235, 255, 0.95) !important;
  border: 1px solid rgba(140, 200, 255, 0.28);
  white-space: nowrap;
}

.user-role-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 7px;
  max-width: 100%;
}

.user-role-badges .role-badge,
:deep(.user-role-badges ion-badge.role-badge) {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  padding: 3px 8px;
  --padding-start: 8px;
  --padding-end: 8px;
  border-radius: 999px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role-badges .role-badge--common,
:deep(.user-role-badges ion-badge.role-badge--common) {
  background: rgba(232, 93, 4, 0.92) !important;
  color: var(--liga-chrome-text) !important;
}

.user-role-badges .role-badge--program,
:deep(.user-role-badges ion-badge.role-badge--program) {
  background: rgba(88, 120, 214, 0.9) !important;
  color: var(--liga-chrome-text) !important;
}

.user-role-badges .role-badge--section,
:deep(.user-role-badges ion-badge.role-badge--section) {
  background: rgba(255, 255, 255, 0.1) !important;
  color: var(--liga-chrome-text) !important;
  border: 1px solid var(--liga-float-glass-border);
}

.user-role-badges .role-badge--other,
:deep(.user-role-badges ion-badge.role-badge--other) {
  background: rgba(255, 255, 255, 0.14) !important;
  color: var(--liga-chrome-text) !important;
}

.user-release-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.user-release-badges .release-badge,
:deep(.user-release-badges ion-badge.release-badge) {
  font-size: 0.65rem;
  padding: 2px 6px;
  background: var(--ion-color-orange) !important;
  color: var(--liga-chrome-text) !important;
}

.user-groups-modal {
  --background: rgba(0, 0, 0, 0.5) !important;
  --backdrop-opacity: 0.6;
}

.user-groups-modal-add-access .user-groups-card-container {
  padding: 12px 16px;
  max-width: 420px;
  max-height: 82vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.user-groups-card-container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: column;
}

.user-groups-card-container ion-card {
  padding: 20px;
  --background: var(--liga-float-glass-bg-strong) !important;
}

.user-groups-modal-add-access .user-groups-card-container ion-card {
  max-height: 100%;
  overflow: visible;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.user-groups-modal-add-access .add-access-card .add-access-content {
  flex: 1 1 auto;
  min-height: 0;
}

/* Модальное окно «Добавление доступа» — карточка */
.add-access-card {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: var(--liga-float-glass-shadow, 0 8px 28px rgba(0, 0, 0, 0.18));
  color: var(--liga-chrome-text);
}

.add-access-header {
  padding-bottom: 8px;
  border-bottom: 1px solid var(--liga-surface-border);
}

.add-access-title {
  color: var(--liga-chrome-text) !important;
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em;
}

.add-access-subtitle {
  color: var(--liga-chrome-text-muted) !important;
  font-size: 0.9rem !important;
  font-weight: 500;
  margin-top: 4px;
}

.add-access-content {
  padding-top: 16px;
  padding-bottom: 8px;
}

.add-access-select-tile {
  min-height: 72px;
  background: var(--liga-surface);
  border: 1px solid var(--liga-surface-border);
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.add-access-select-tile:hover {
  background: var(--liga-float-glass-bg-strong);
  border-color: rgba(235, 89, 82, 0.45);
}

.add-access-tile-label {
  display: block;
  color: var(--liga-chrome-text);
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.add-access-placeholder {
  color: var(--liga-chrome-text-muted);
  font-size: 0.85rem;
}

.add-access-chip {
  --background: var(--ion-color-orange) !important;
  --color: #ffffff !important;
  margin: 4px;
}

.add-access-actions {
  gap: 12px;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid var(--liga-surface-border);
  justify-content: flex-end;
}

.add-access-actions .add-access-btn-cancel {
  --border-color: var(--ion-color-orange) !important;
  --color: var(--liga-chrome-text) !important;
  --border-radius: 22px;
  font-weight: 600;
}

.add-access-actions .add-access-btn-save {
  --background: var(--ion-color-orange) !important;
  --background-activated: var(--ion-color-orange-tint) !important;
  --color: #ffffff !important;
  --border-radius: 22px;
  font-weight: 600;
}

.user-groups-card-container ion-card-title {
  color: var(--liga-chrome-text) !important;
  font-weight: bold;
  font-size: 1.8em;
  letter-spacing: 0.07em;
}

.user-groups-card-container ion-card-content {
  color: var(--liga-chrome-text-muted);
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.07em;
}

.user-groups-card-container ion-item {
  --background: transparent;
  --color: var(--liga-chrome-text) !important;
  color: var(--liga-chrome-text) !important;
}

.user-groups-card-container ion-item ion-icon {
  color: var(--liga-chrome-text) !important;
  cursor: pointer;
}

.user-groups-card-container .user-search {
  --background: var(--liga-surface) !important;
  --color: var(--liga-chrome-text) !important;
  --placeholder-color: var(--liga-chrome-text-muted) !important;
  --icon-color: var(--liga-chrome-text-muted) !important;
}

.user-groups-btn-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.user-groups-btn-container ion-button {
  --background: transparent;
  --background-activated: var(--ion-color-orange-tint);
  --color: var(--liga-chrome-text) !important;
  color: var(--liga-chrome-text) !important;
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
  --border-color: var(--ion-color-orange) !important;
  --border-style: solid !important;
  --border-width: 1px !important;
}

.user-groups-btn-container ion-button.user-groups-accept-button,
.user-groups-accept-button {
  --background: var(--ion-color-orange) !important;
  --background-activated: var(--ion-color-orange-tint) !important;
  --color: #ffffff !important;
  color: #ffffff !important;
}

.user-groups-select-area {
  min-height: 10%;
  background: var(--liga-surface);
  border-radius: 15px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.add-access-select-tile .chip-area {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  max-height: 20vh;
  overflow-y: auto;
  width: 100%;
}

.user-groups-select-area ion-label {
  color: var(--liga-chrome-text-muted);
}

.user-groups-select-area ion-chip {
  z-index: 100;
}

.chip-area {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-height: 15vh;
  overflow: scroll;
}

.selector-arrow {
  justify-self: end;
  align-self: center;
}

.list-selector-content {
  max-height: 40vh;
  overflow: scroll;
}

.list-selector-content ion-list {
  background: transparent !important;
}

.list-selector-content ion-item {
  --border-color: var(--liga-surface-border) !important;
  --border-radius: 5px;
}

.selected-item {
  --background: var(--ion-color-orange) !important;
  --color: #ffffff !important;
  color: #ffffff !important;
}

.users-loading,
.users-empty {
  padding: 24px 16px;
  text-align: center;
  color: var(--liga-chrome-text-muted);
}

.users-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.users-pagination-label {
  color: var(--liga-chrome-text);
  font-size: 0.9rem;
  min-width: 140px;
  text-align: center;
}

.users-panel-btn-activity {
  --border-color: var(--liga-surface-border);
  --color: var(--liga-chrome-text);
}

.users-activity-modal {
  --width: min(960px, 96vw);
  --height: min(92vh, 920px);
  --background: var(--liga-float-glass-bg-strong) !important;
  --ion-background-color: var(--liga-float-glass-bg-strong) !important;
}

.users-activity-modal::part(content) {
  background: var(--liga-float-glass-bg-strong) !important;
  border: 1px solid var(--liga-float-glass-border);
  color: var(--liga-chrome-text);
}

.users-activity-content {
  --background: var(--liga-page-bg) !important;
  background: var(--liga-page-bg) !important;
  color: var(--liga-chrome-text);
}

.users-activity-body {
  padding-bottom: 24px;
}

.activity-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.activity-summary-card {
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--liga-surface);
  border: 1px solid var(--liga-surface-border);
}

.activity-summary-card span {
  display: block;
  color: var(--liga-chrome-text-muted);
  font-size: 0.85rem;
  margin-bottom: 6px;
}

.activity-summary-card strong {
  color: var(--liga-chrome-text);
  font-size: 1.4rem;
}

.activity-chart-block,
.activity-sessions-block {
  margin-bottom: 20px;
  padding: 16px;
  border-radius: 16px;
  background: var(--liga-float-glass-bg-strong);
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: var(--liga-float-glass-shadow, none);
  color: var(--liga-chrome-text);
}

.activity-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.activity-chart-header h3 {
  margin: 0;
  color: var(--liga-chrome-text);
  font-size: 1rem;
}

.activity-chart-header span {
  color: var(--liga-chrome-text-muted);
  font-size: 0.85rem;
}

.activity-loading {
  color: var(--liga-chrome-text-muted);
  text-align: center;
  padding: 16px 0;
}

.activity-chart {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  min-height: 180px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.activity-chart-bar-wrap {
  flex: 1 0 42px;
  min-width: 42px;
  max-width: 56px;
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.activity-chart-bar {
  width: 100%;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, #ff8533 0%, #e85d04 100%);
  min-height: 8px;
}

.activity-chart-count {
  color: var(--liga-chrome-text);
  font-size: 0.75rem;
  font-weight: 600;
}

.activity-chart-date {
  color: var(--liga-chrome-text-muted);
  font-size: 0.7rem;
}

.activity-sessions-list {
  display: grid;
  gap: 10px;
  max-height: 42vh;
  overflow-y: auto;
}

.activity-session-card {
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--liga-surface);
  border: 1px solid var(--liga-surface-border);
}

.activity-session-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.activity-session-top strong {
  color: var(--liga-chrome-text);
}

.activity-session-top span,
.activity-session-meta span {
  color: var(--liga-chrome-text-muted);
  font-size: 0.85rem;
}

.activity-session-meta {
  display: grid;
  gap: 4px;
}

@media (max-width: 720px) {
  .activity-summary {
    grid-template-columns: 1fr;
  }

  .users-pagination-label {
    min-width: auto;
    font-size: 0.82rem;
  }
}
</style>